var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.userInfo ? _c('div', {
    staticClass: "card-head"
  }, [_c('div', {
    staticClass: "wrap",
    style: {
      'background-image': _vm.userInfo.big_face ? "url(".concat(_vm.turnHttps(_vm.userInfo.big_face), ")") : "url(".concat(_vm.defaultUserPortrait(_vm.userInfo), ")")
    }
  }, [_c('div', {
    staticClass: "btn-shadow"
  }), _vm._v(" "), _vm.videoid ? _c('div', {
    staticClass: "live"
  }, [_vm._m(0), _vm._v("\n            " + _vm._s(_vm.$t('home.live')) + "\n       ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "props"
  }, [_vm.userInfo.level ? _c('div', {
    staticClass: "level",
    style: {
      'background-image': _vm.getLevelImage(_vm.userInfo.level)
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.userInfo.level))])]) : _vm._e(), _vm._v(" "), _vm.userInfo.anchor_level ? _c('div', {
    staticClass: "anchor-level",
    style: {
      'background-image': _vm.getAnchorLevelImage(_vm.userInfo.anchor_level)
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("BLV." + _vm._s(_vm.userInfo.anchor_level))])]) : _vm._e(), _vm._v(" "), _vm.userInfo.age && (_vm.userInfo.sex == '1' || _vm.userInfo.sex == '0') ? _c('div', {
    staticClass: "sex-and-age",
    class: _vm.getSexClass(_vm.userInfo.sex)
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.userInfo.age))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "level"
  })])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "watch"
  }, [_c('i', {
    staticClass: "f"
  }), _vm._v(" "), _c('i', {
    staticClass: "s"
  }), _vm._v(" "), _c('i', {
    staticClass: "t"
  })]);
}];
export { render, staticRenderFns };